
import { computed, defineComponent } from 'vue'
import JrInputView from '@/components/jr-parts/JrInputView.vue'

export default defineComponent({
  name: 'JrNumber',
  emits: ['update:modelValue'],
  components: { JrInputView },
  props: {
    modelValue: {
      type: [Number, String],
      required: false,
      default: null,
    },
    placeholder: {
      type: String,
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
    max: {
      type: Number,
      required: false,
    },
    min: {
      type: Number,
      required: false,
    },
    step: {
      type: Number,
      required: false,
    },
    // emit時にstringに変換するか
    isString: {
      type: Boolean,
      required: false,
      defalut: false,
    },
    // スピンボタンの表示/非表示
    isVisibleSpin: {
      type: Boolean,
      required: false,
      defalut: false,
    },
    // blurイベントで小数点を補完する桁数
    autoDecimalOfBlur: {
      type: Number,
      required: false,
      default: null,
    },
  },
  setup(props, context) {
    return {
      classes: computed(() => {
        return { 'no-spin': !props.isVisibleSpin }
      }),
      update: (event: string) => {
        if (props.isString) {
          context.emit('update:modelValue', event)
        } else {
          context.emit('update:modelValue', Number(event))
        }
      },
      blur: () => {
        if (props.autoDecimalOfBlur != null && props.modelValue !== '') {
          const value = Number(props.modelValue).toFixed(props.autoDecimalOfBlur)
          if (props.isString) {
            context.emit('update:modelValue', value)
          } else {
            context.emit('update:modelValue', Number(value))
          }
        }
      },
    }
  },
})
